import { useMediaQuery } from 'react-responsive';

import { ViewSizeType } from '@types';

export interface UseGetCurrentBreakpointHookOutput {
	currentView: ViewSizeType;
	isMobile: boolean;
}

export const useGetCurrentBreakpoint = (): UseGetCurrentBreakpointHookOutput => {
	const desktopScreen = useMediaQuery({ minWidth: 1200 });
	const tabletScreen = useMediaQuery({ minWidth: 992, maxWidth: 1199 });
	const mobileScreen = useMediaQuery({ minWidth: 1, maxWidth: 991 });

	// Derive currentView synchronously from the media-query booleans.
	// Previously this went through useState + useEffect which caused an extra
	// render on every mount (first render returned the 'smallView' default,
	// then the effect fired setState → second render). With 8+ consumers this
	// produced a visible double-render flick on every component mount.
	const currentView: ViewSizeType = mobileScreen
		? 'smallView'
		: desktopScreen
		? 'bigView'
		: tabletScreen
		? 'tabletView'
		: 'smallView';

	const isMobile = currentView === 'smallView';

	return {
		currentView,
		isMobile,
	};
};
